module.exports = __webpack_public_path__ + "img/giraff-logo.2ba22b7a.png";